import { Grid, Paper, Stack, Typography } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import type { SelectedCompany } from "./hooks/SelectedCompany";
import { getItemSx } from "./utils/getItemSx";

export interface CompanyItemProps {
  company: SelectedCompany;
  companyBranding: ListItemData | undefined;
  active?: boolean;
  selectable?: boolean;
  Action?: JSX.Element;
  inProgress: boolean;
  onSelected?: (company: SelectedCompany) => void;
}

export function CompanySingleReportListItem({
  company,
  companyBranding,
  active,
  selectable,
  children,
  Action,
  inProgress,
  onSelected,
}: PropsWithChildren<CompanyItemProps>) {
  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        ...getItemSx(selectable, active, inProgress, theme),
        width: "100%",
      })}
      onClick={() => selectable && onSelected?.(company)}
    >
      <Stack>
        <Stack direction="row" sx={{ pr: 1, alignItems: "center" }}>
          <Grid
            container
            sx={{ pr: 1, pl: 2, pt: 1.5, spacing: 1.5, alignItems: "center", direction: "row", width: "100%" }}
          >
            <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flexGrow: 1 }}>
              <img src={companyBranding?.iconSrc} alt="" width={24} height={24} />
              <Typography variant="subtitle1">{companyBranding?.label}</Typography>
            </Stack>
          </Grid>
          {Action}
        </Stack>
        <Grid container sx={{ width: "100%" }}>
          <Grid
            container
            sx={{
              flex: 1,
              pl: 2,
              pr: 1.5,
              pb: 0.5,
              height: (theme) => theme.spacing(4.8),
              alignItems: "center",
              width: "100%",
            }}
          >
            {children}
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
}
